const yup = require("yup");

// Schema for createcollegerules
const create = yup.object({
  programme: yup.string().required("Programme is required"),
  level: yup.string().required("Level is required"),
  semester: yup.string().required("Semester is required"),
  serviceID: yup.string().required("ServiceID is required"),
  indigene: yup.string().required("Indigene is required"),
  status: yup.boolean().required("Status is required"),
  isnewstudent: yup.boolean().required("Is New Student is required"),
});

module.exports = {
  create,
};
